<div>
    @let isProfileAssigned = assignedProfileData?.length > 0;

    @if (isLoading) {
        <div class="card tw-flex tw-justify-center">
            <p-progress-spinner  styleClass="p-progress-spinner-lg" strokeWidth="4" />
        </div>
    }

    @if (!isLoading && !isProfileAssigned) {
        <p class="tw-mb-0" [innerHTML]="'adminPerformanceProfiles.archiveDialog.emptyProfileDescription{{profileName}}' | transloco:{profileName: profileData?.name}"></p>
    }

    @if (!isLoading && isProfileAssigned) {
        <div class="tw-flex tw-flex-col">
            <p class="tw-mb-4" [innerHTML]="'adminPerformanceProfiles.archiveDialog.assignedProfileDescription{{profileName}}' | transloco:{profileName: profileData?.name}"></p>
            <div class="profile-list-wrapper tw-py-4 tw-px-14 tw-max-h-60 tw-overflow-y-auto">
                @for (assignedProfile of assignedProfileData; track assignedProfile.id) {
                    <div>
                        <p class="tw-font-bold tw-mb-2">{{assignedProfile?.page?.title}}</p>
                        <div class="tw-flex tw-items-center">
                            <a [href]="assignedProfile?.page?.url"
                                [attr.aria-label]="'adminPerformanceProfile.archiveDialog.visitPageAriaLabel' | transloco"
                                target="_blank"
                                rel="noopener noreferrer">
                                <span>{{assignedProfile?.page?.url}}</span>
                                <i class="pi pi-external-link tw-ml-2" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                }
            </div>
            <p-paginator
                (onPageChange)="onPageSizeChange($event)"
                [first]="tableFirstOffset"
                [rows]="perPage"
                [totalRecords]="total"
                [rowsPerPageOptions]="AVAILABLE_PAGE_SIZE"
                data-test="admin-performance-profiles-archive-profile-table-paginator"
                styleClass="tw-mt-3"
                dropdownAppendTo="body"
            />
        </div>
    }
    <div class="tw-flex tw-justify-end tw-mt-6">
        <p-button
            [label]="'adminPerformanceProfile.archiveDialog.cancelBtnLabel' | transloco"
            severity="secondary"
            variant="text"
            class="tw-mr-4"
            data-test="admin-performance-proile-archive-profile-cancel-button"
            (onClick)="cancel()"
            [disabled]="isLoading"
        />
        <p-button
            [label]="'adminPerformanceProfile.archiveDialog.archiveBtnLabel' | transloco"
            severity="primary"
            data-test="admin-performance-proile-archive-profile-confirm-button"
            (onClick)="confirm()"
            [disabled]="isLoading"
        />
    </div>
</div>
